module.exports = __webpack_public_path__ + "img/NC.015350ce.svg";